export default function isLikeTrue(value: boolean | string | null) {
  return (
    value === true ||
    (typeof value === 'string' && value.toLowerCase() === 'y') ||
    (typeof value === 'string' && value.toLowerCase() === 'true')
  );
}
